(function (angular, _) {
    var MyHippoProducerServices = angular.module('MyHippoProducer.Services', ['ngMaterial']);
    MyHippoProducerServices.factory('APIService', function ($log,toaster, UserService, Auth0Service, $q, $http, $rootScope) {
        const {API_HOST: apiHost} = window.appConfig;

        const getHeaders = () => Auth0Service.getPodToken().then((podToken) => ({
            Authorization: `Bearer ${podToken}`
        })).catch((error) => {
            console.error('Error while trying to get POD token:', error);
        });

        var APIService = {
            login: function (token) {
                return getHeaders().then(headers => apiRequest($http.post(
                    `${apiHost}/v1/producer/user/login`,
                    { token },
                    { headers }
                )));
            },
            logout: function () {
                return getHeaders().then(headers => apiRequest($http.post(
                    `${apiHost}/v1/producer/user/logout`,
                    null,
                    { headers }
                )));
            },
            findCurrentUser: function (params) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/user`,
                    method: 'GET',
                    params: params,
                    headers
                })).then(userData => {
                    UserService.init(userData);
                    return userData;
                }));
            },
            getRCEDocument: function (policyId) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/policy/${policyId}/rce_document`,
                    method: 'GET',
                    headers
                })));
            },
            getProducerQuoteId: function (policyId) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/policy/${policyId}/producer_quote_id`,
                    method: 'GET',
                    headers
                })));
            },
            findPolicies: function (params) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/policy`,
                    method: 'GET',
                    params: params,
                    headers
                })));
            },
            findPendingPolicies: function (params) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/pendingPolicy`,
                    method: 'GET',
                    params: params,
                    headers
                })));
            },
            findPolicyById: function (policyId) {
                return getHeaders().then(headers => apiRequest($http.get(`${apiHost}/v1/producer/policy/${policyId}`, { headers })));
            },
            createLead: function (data) {
                if (UserService.isPolicyCreationDisabled()) {
                    const errorMessage = 'Not allowed to create policies';
                    $log.error(errorMessage);
                    return Promise.reject(errorMessage);
                } else {
                    return getHeaders().then(headers => apiRequest($http({
                        url: `${apiHost}/v1/producer/producerlead`,
                        method: 'POST',
                        data: data,
                        headers
                    })));
                }
            },
            findLeads: function (params) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/producerlead`,
                    method: 'GET',
                    params: params,
                    headers
                })));
            },
            downloadProducersReport: function () {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/producer/producers_report`,
                    method: 'GET',
                    headers
                })));
            },
            findProducers: function (params) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/producer`,
                    method: 'GET',
                    params: params,
                    headers
                })));
            },
            findProducerById: function (producerId) {
                return getHeaders().then(headers => apiRequest($http.get(`${apiHost}/v1/producer/producer/${producerId}`, { headers })));
            },
            findLeadUrl: function (leadId, pageId, orgIdOverride) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/producerlead/${leadId}/url`,
                    method: 'GET',
                    params: { pageId: pageId, orgIdOverride },
                    headers
                })));
            },
            updateProducer: function (producerId, updates) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/producer/${producerId}`,
                    method: 'POST',
                    data: updates,
                    headers
                })));
            },
            changeProducerPassword: function (producerId) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/producer/${producerId}/change_password`,
                    method: 'POST',
                    headers
                })));
            },
            findOrganizations: function () {
                return getHeaders().then(headers => apiRequest($http.get(`${apiHost}/v1/producer/organization`, { headers })));
            },
            findOrganization: function (organizationId) {
                return getHeaders().then(headers => apiRequest($http.get(`${apiHost}/v1/producer/organization/${organizationId}`, { headers })));
            },
            checkOrganizationRestriction: function (organizationId, state, product) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/organization/${organizationId}/restriction`,
                    method: 'GET',
                    params: {
                        state,
                        product
                    },
                    headers
                })));
            },
            updateOrganization: function (organizationId, updates) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/organization/${organizationId}`,
                    method: 'POST',
                    data: updates,
                    headers
                })));
            },
            findAvailableOrganizationsForUser: function () {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/current_orgs`,
                    method: 'GET',
                    headers
                })));
            },
            updatePolicyEffectiveDate: function (policyId, effectiveDate) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/policy/${policyId}/effective_date`,
                    method: 'POST',
                    data: { effective_date: effectiveDate },
                    headers
                })));
            },
            updatePolicyMortgages: function (policyId, lenders) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/policy/${policyId}/mortgages`,
                    method: 'POST',
                    data: { lenders },
                    headers
                })));
            },
            updatePolicyOrganization: function (policyId, orgId) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/policy/${policyId}/organization`,
                    method: 'POST',
                    data: { orgId },
                    headers
                })));
            },
            updateProducerPolicy: function (policyId, context, updates) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/policy/${policyId}/update/${context}`,
                    method: 'POST',
                    data: {policyInfo: updates},
                    headers
                })));
            },
            updatePersonalInformation: function(policyId, updates) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/policy/${policyId}/personal_information`,
                    method: 'POST',
                    data: updates,
                    headers
                })));
            },

            // download policy report
            downloadLeadReport: function (filters) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/leadReport`,
                    method: 'GET',
                    params: filters,
                    headers
                })));
            },
            // download policy report
            downloadPolicyReport: function (filters) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/policyReport`,
                    method: 'GET',
                    params: filters,
                    headers
                })));
            },

            // notifications
            findNotifications: function (params) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/notification`,
                    method: 'GET',
                    params: params,
                    headers
                })));
            },
            markNotificationsRead: function (params) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/notification/mark_read`,
                    method: 'POST',
                    data: params,
                    headers
                })));
            },
            markNotificationsUnread: function (params) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/notification/mark_unread`,
                    method: 'POST',
                    data: params,
                    headers
                })));
            },
            updateNotificationFavorite: function (notificationId, favorite) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/notification/${notificationId}/favorite`,
                    method: 'POST',
                    data: {favorite},
                    headers
                })));
            },
            resendCustomerAgreementEmail: function (policyId) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/policy/${policyId}/resend_agreement`,
                    method: 'POST',
                    cache: false,
                    headers
                })));
            },
            downloadYTDReport: function (url) {
                return getHeaders().then(headers => apiRequest($http({ url, method: 'POST', headers })));
            },

            getApplicationId: function(leadId) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/producerlead/${leadId}/application_id`,
                    method: 'GET',
                    headers
                })));
            },

            setIntent: function(quoteId) {
                return getHeaders().then(headers => apiRequest($http({
                    url: `${apiHost}/v1/producer/producerlead/${quoteId}/intent`,
                    method: 'POST',
                    headers
                })));
            },
        };

        return APIService;

        function apiRequest (request) {
            const deferred = $q.defer();

            request.then(function (res) {
                deferred.resolve(res.data);
            }, function (err) {
                $log.info('this is error', err);

                if (err.data && err.data.error) {
                    // toaster.pop('error', "Error", err.data.error.customMsg);
                } else {
                    // toaster.pop('error', "Error", "");
                }
                deferred.reject(err.data);
            });

            return deferred.promise;
        }
    });

    MyHippoProducerServices.factory('UploadService', function () {
        return {};
    });

    MyHippoProducerServices.factory('TimeRangeFilterService', function () {
        const validTimeRanges = ['month_to_date', 'last_30_days', 'quarter_to_date', 'year_to_date', 'last_12_months', 'last_year', ''];
        let currentTimeRange = 'last_30_days'; // default
        return {
            setTimeRange: function (timeFrame) {
                if (validTimeRanges.includes(timeFrame)) {
                    currentTimeRange = timeFrame;
                }
            },
            getTimeRange: function () {
                return currentTimeRange;
            }
        };
    });
})(window.angular, window._);
